import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/services/toxicology/elemental-impurities-reports")({
  beforeLoad: () => { throw redirect({ href: "/zh-cn/services/regulatory-toxicology/elemental-impurities-reports", statusCode: 301 }); },
});
